module.exports = __webpack_public_path__ + "img/leader-4.3f6fcdfb.png";